import axios from "axios";
import { Toast } from "../../util/Toast";

import {
  SEND_REWARD,
  GET_REWARD_HISTORY,
  GET_USER_FRAMES,
  GET_USER_SVGAS,
  GET_USER_BACKGROUNDS,
  GET_USER_GIFTS,
  GET_USER_INVENTORY_HISTORY,
} from "./types";

export const getRewardHistory = () => (dispatch) => {
  axios
    .get("inventory?reward=true")
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: GET_REWARD_HISTORY,
          payload: res.data.inventoryHistory,
        });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => {
      console.log(error);
      Toast("error", error.message);
    });
};

export const sendReward = (data, adminId) => (dispatch) => {
  axios
    .post("inventory?reward=true", { data: data, adminId: adminId })
    .then((res) => {
      if (res.data.status === true) {
        dispatch({
          type: SEND_REWARD,
          payload: res.data.inventory,
        });
        Toast("success", res.data.message);
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => Toast("error", error.message));
};

export const getUserInventory = (userId, type) => (dispatch) => {
  axios
    .get(`admin/users/${userId}/inventory/${type}`)
    .then((res) => {
      if (res.data.status === true) {
        if (type === "frame") {
          dispatch({
            type: GET_USER_FRAMES,
            payload: res.data.inventory,
          });
        } else if (type === "background") {
          dispatch({
            type: GET_USER_BACKGROUNDS,
            payload: res.data.inventory,
          });
        } else if (type === "gift") {
          dispatch({
            type: GET_USER_GIFTS,
            payload: res.data.inventory,
          });
        } else {
          dispatch({
            type: GET_USER_SVGAS,
            payload: res.data.inventory,
          });
        }

        console.log(`type: ${type}`, res.data.inventory);
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => Toast("error", error.message));
};

export const getUserInventoryHistory = (userId) => (dispatch) => {
  axios
    .get(`inventory/${userId}/history`)
    .then((res) => {
      if (res.data.status === true) {
        dispatch({
          type: GET_USER_INVENTORY_HISTORY,
          payload: res.data.inventoryHistory,
        });
      } else if (res.data.message === "No data found!") {
        dispatch({
          type: GET_USER_INVENTORY_HISTORY,
          payload: [],
        });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => Toast("error", error.message));
};
